import * as React from 'react';

import { Access } from './parts/access';
import { useFeatureTogglesContext } from '../context/featureToggles';
import { StandardPage } from './parts/standardPage';
import { UserManagement } from '../containers/users/index';
import { AccessDeniedToPage } from '../containers/access-denied/accessDeniedToPage';

export function UserManagementRoute() {
  const featureToggles = useFeatureTogglesContext();

  if (featureToggles.hideUserManagement) {
    return (
      <StandardPage>
        <AccessDeniedToPage />
      </StandardPage>
    );
  }

  return (
    <Access role="administrator">
      <StandardPage>
        <UserManagement />
      </StandardPage>
    </Access>
  );
}
